// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Zr-pD","right":"styles_right__oBcys"};